import {
  put, takeLatest,
} from 'redux-saga/effects';
import { boundaryToolBTGsSelector } from '~/store/boundaryTerritoryGroups/boundaryTool/boundaryToolBTGs.selectors';
import { select } from '../../../_shared/utils/saga/effects';
import {
  BOUNDARY_TERRITORY_GROUP_FETCH_SUCCESS, BOUNDARY_TERRITORY_GROUP_REMOVE_COMPLETED,
} from '../../boundaryTerritoryGroups/boundaryTerritoryGroups.actionTypes';
import { type BoundaryTerritoryGroup } from '../../boundaryTerritoryGroups/boundaryTerritoryGroups.state';
import { MAP_SETTINGS_READY_SET } from '../ready/mapSettingsReady.actionTypes';
import { mapSettingsBoundariesSetPrimaryBoundaryGroupId } from './mapSettingsBoundaries.actionCreators';

export function* mapSettingsBoundariesSagas() {
  yield takeLatest([
    BOUNDARY_TERRITORY_GROUP_REMOVE_COMPLETED,
    BOUNDARY_TERRITORY_GROUP_FETCH_SUCCESS,
    MAP_SETTINGS_READY_SET,
  ], validatePrimaryBoundaryGroupId);
}

function* validatePrimaryBoundaryGroupId() {
  const boundaryTerritoryGroups: ReadonlyArray<BoundaryTerritoryGroup> =
    yield select(boundaryToolBTGsSelector);

  const currentPrimaryBoundaryGroupId: number | null = yield select<number | null>(
    state => state.map.mapSettings.data.boundaries.primaryBoundaryGroupId
  );

  const isMapSettingsReady: boolean = yield select<boolean>(state => state.map.mapSettings.isReady);

  if (!isMapSettingsReady) {
    return;
  }

  const boundaryTerritoryGroupsIds = boundaryTerritoryGroups.map(territoryGroup => territoryGroup.boundaryGroupId);

  if (!boundaryTerritoryGroupsIds.length) {
    return;
  }

  if (!currentPrimaryBoundaryGroupId || !boundaryTerritoryGroupsIds.includes(currentPrimaryBoundaryGroupId)) {
    if (boundaryTerritoryGroupsIds[0]) {
      yield put(mapSettingsBoundariesSetPrimaryBoundaryGroupId(boundaryTerritoryGroupsIds[0]));
    }
  }
}
